<div class="login_p_section">
  <div class="container newheightx d-flex align-items-center justify-content-center">
    <div class="row w-100 align-items-center">
     
      <div class="col-md-12">
        <div id="first-form">
          <mat-card appearance="outlined" class="card newrt p-4">
              <div class="login_img_section">
              <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
            </div> 
            
            <p class="join_heading">
              Join the platform and manage your Salon, Parlor, Spa, Makeup Studio, Gym, Fitness, Yoga and Wellness Center like never before.
            </p>
            <form>

         
              <mat-form-field class="w-100" appearance="outline">
                <mat-select
                  placeholderLabel="Search"
                  name="primarySelectedSpecialityCtrl"
                  [(value)]="selectedCountry"
                  (selectionChange)="onCountrySelected($event)"
                  #primarySpecialitiesSelector
                >
                  <mat-option>
                    <ngx-mat-select-search
                      noEntriesFoundLabel="no results found"
                      name="countrysearch"
                      placeholderLabel="Enter country name"
                      [formControl]="searchString"
                      (keyup)="onKey()"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let country of countryList"
                    [value]="country"
                  >
                    {{ country.flag }} {{ country.name }}
                    {{ "(" + country.dial_code + ")" }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Phone Number</mat-label>
                <input
                  matInput
                   inputmode="numeric"
                  pattern="[0-9]*"
                  type="tel"
                  name="phone"
                  minLength="3"
                  maxlength="17"
                  [(ngModel)]="phone"
                  placeholder="Enter your phone number"
                  smNumericOnly
                />
              </mat-form-field>

              <div class="verify_btn">
                <button
                  mat-flat-button
                  color="primary"
                  class="full-width"
                  [disabled]="
                    
                    !phone || phone.length < 3 || phone.length > 17"
                  #submitButton
                  (click)="onSendOTP()"
                >
                  Verify mobile
                </button>
              </div>
            </form>
            <p class="footer-text">
              By verifying mobile and registering with us, you are agreeing and consenting to our
              <a href="https://lookzup.com/terms" target="_blank">Terms of Services</a> and
              <a href="https://lookzup.com/privacy" target="_blank" >Privacy policy</a>.
            </p>

            <p class="footer-text">
              Looking for beauty and grooming services for you and your family?
              <a (click)="openCustomerWebsite()" style="text-decoration: underline;color: #222;cursor: pointer;"
                >Login to LookzUp Marketplace.</a>
            </p>

            <!-- login end -->
          </mat-card>
        </div>

        <!-- otp start -->
        <div  class="width_small" *ngIf="otpReceived && !showProfileForm && !toshowblockedmessage && !registrationDone">
          <mat-card appearance="outlined" class="card newrt p-4">
            <!-- <h4 class="mb-2">Welcome to LookzUp</h4> -->
            <div class="login_img_section">
              <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
            </div> 
            <p class="join_heading">
              Join the platform and manage your Salon, Parlor, Spa, Makeup Studio, Gym, Fitness, Yoga and Wellness Center like never before.
            </p>
            <!-- login -->

            <form>
              <div class="tht_sectionm">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Phone Number</mat-label>
                  <input matInput [value]="userPhoneNumber" disabled type="tel" />
                  <mat-icon matSuffix class="material-icons-outlined" (click)="onbacklogin()" style="cursor: pointer;">edit</mat-icon>
                  <!-- <button mat-icon-button matSuffix (click)="onbacklogin()">
                  </button> -->
                </mat-form-field>
              </div>
              <div class="otp-container">
                <input
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  autocomplete="one-time-code"
                  name="otp"
                  maxlength="6"
                  class="otp-input"
                  (input)="onFirstInputChange($event)"
                  [(ngModel)]="otp[0]"
                  id="box0"
                  (paste)="handlePaste($event)"
                />
                <input
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 1)"
                  name="second"
                  [(ngModel)]="otp[1]"
                  id="box1"
                />
                <input
                  type="tel"
                   inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 2)"
                  name="third"
                  [(ngModel)]="otp[2]"
                  id="box2"
                />
                <input
                type="tel"
                  maxlength="1"
                   inputmode="numeric"
                  pattern="[0-9]*"
                  class="otp-input"
                  (input)="onInput($event, 3)"
                  name="fourth"
                  [(ngModel)]="otp[3]"
                  id="box3"
                />
                <input
                type="tel"
                  maxlength="1"
                   inputmode="numeric"
                  pattern="[0-9]*"
                  class="otp-input"
                  (input)="onInput($event, 4)"
                  name="fifth"
                  [(ngModel)]="otp[4]"
                  id="box4"
                />
                <input
                  type="tel"
                  maxlength="1"
                   inputmode="numeric"
                  pattern="[0-9]*"
                  class="otp-input"
                  (input)="onInput($event, 5)"
                  name="sixth"
                  [(ngModel)]="otp[5]"
                  id="box5"
                />
              </div>
              <div class="small_tht">
                <p>
                  Enter the verification code you received in your mobile from LookzUp platform.
                </p>
              </div>

              <div class="verify_btn" >
                <button mat-flat-button color="primary" class="full-width" [disabled]="checkOtpDisability()" (click)="onSignIn()">
                  Confirm
                </button>
              </div>
              <div class="resend_code_heading">
                <p>
                  Haven't received any verification code yet? <br> <a href="javascript:void(0)" (click)="onresend()" 
    [style.pointerEvents]="resendDisabled ? 'none' : 'auto'"
    [style.color]="resendDisabled ? 'gray' : '#222'" class="resend_tter">Re-send code</a>.
                </p>
              </div>
            </form>
          </mat-card>
        </div>

        <div class="width_small" *ngIf="showProfileForm && !toshowblockedmessage && !registrationDone">
          <mat-card appearance="outlined" class="card newrt p-4">
            <div class="login_img_section">
              <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
            </div> 
            <p class="join_heading">
              Join the platform and manage your Gym, Salon, Yoga, Wellness Center, Parlor, Spa, Makeup and Fitness Studio like never before. Share a little about you.
            </p>
          <form [formGroup]="signInForm">
            <ng-template matStepLabel>Profile</ng-template>
            <div class="row g-2 mb-3 justify-content-between phone-field">
              
              <mat-form-field appearance="outline" class="col-12">
                <mat-label>Your name</mat-label>
                <input
                  matInput
                  
                  formControlName="name"
                  required
                />
                
              </mat-form-field>
              <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()">
                  <mat-label>Date of birth</mat-label>
                  <input matInput [matDatepicker]="picker1" formControlName="dob" readonly>
                  <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                </mat-form-field>
                <!-- <div class="radio_group">
                  <label>Gender: </label>
                  <mat-radio-group formControlName="gender">
                    <mat-radio-button value="Male">Male</mat-radio-button>
                    <mat-radio-button value="Female">Female</mat-radio-button>
                    <mat-radio-button value="Others">Others</mat-radio-button>
                  </mat-radio-group>
                </div> -->
                <mat-form-field appearance="outline">
                  <mat-label>Address</mat-label>
                  <input
                  formControlName="address"
                    matInput
                    (input)="updateSearchResults()"
                    [matAutocomplete]="auto"
                  />
                  <!-- <mat-icon matSuffix class="material-icons-outlined"
                    >person_pin_circle</mat-icon
                  > -->
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option
                      *ngFor="let item of autocompleteItems"
                      (click)="selectSearchResult(item)"
                    >
                      {{ item.description }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-hint
                  style="
                    color: red;
                    font-size: 13px;
                    margin-top: 0px;
                    position: relative;
                    top: -10px;
                  "
                  align="end"
                  *ngIf="isAddressNotSelectedFromList"
                >
                  Please pick an address from the dropdown.
                </mat-hint>
            </div>
            
            <button
              mat-flat-button
             style="    width: 100%;
             background: #FFC107;
             border-radius: 20px;
             color: white;
             height: 45px;"
              class="w-100"
              [disabled]="signInForm.invalid"
              (click)="onRegister()"
            >
              Save and Go
            </button>
            <div class="resend_code_heading" style="margin-top: 20px;">
              <p>
                Want to exit from here? <a href="javascript:void(0)" (click)="logout()">Logout.</a>
              </p>
            </div>
          </form>
        </mat-card>
        </div>
        <div *ngIf="toshowblockedmessage && !registrationDone">
          <mat-card appearance="outlined" class="card newrt p-4">
          <div>
            <h1 class="head-text" >Your account is blocked.</h1>
            <p class="head-text1" >LookzUp Admin blocked your account due to the following reason:</p>
            <p class="head-text1" style="font-weight: 600;">{{blockedUserData.block_reason}}</p>
          </div>
          <div style="margin: 20px 0px 0px;border-top: 1px solid lightgrey;padding-top: 15px;">
            <p class="">Provide grievance or request unblock.</p>
            <mat-form-field class=" w-100"  style="margin-top: 0px;" appearance="outline" >
              <textarea matInput #input placeholder="Enter your grievance" autocomplete="off" [(ngModel)]="blockedUserGrievance"></textarea>
            </mat-form-field>
          </div>
          <div style="    text-align: right;">
            <button
            style="margin-bottom: 20px;"
            mat-flat-button
            color="accent"
            [disabled]="!blockedUserGrievance"    
            (click)="sendUnblockRequest()"
          >
            Send
          </button>
          </div>
        </mat-card>
        </div>

       <!-- mobile start-->

  <!-- mobile end -->

      </div>
    </div>
  </div>


</div>
